/**
 * @file_purpose  page for showing cost contact form 
 * @author Sucheta Singha
 * @Date_Created 21-08-2024
 * @Date_Modified 21-08-2024
 */
import React, { useState, useEffect } from 'react'
import { useHistory, useParams, useLocation, Link } from 'react-router-dom'
import {
    CForm,
    CInput,
    CInputCheckbox,
    CButton,
    CTextarea,
    CSpinner,
    CSelect,
    CInputGroup,
    CDropdown
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify';
import GeneralService from "src/apis/GeneralService";
import Constants from "src/Utility/Constants";
import RouteURL from "src/apis/ApiURL";
import moment from "moment";
import helpers from 'src/Utility/Helpers';
import masterData from 'src/Utility/MasterData';
import Select from 'react-select'

export default function CostContactForm() {
    const RAT_WEBSITE_ORIGIN = "https://ems.redappletech.com";
    const history = useHistory();
    const location = useLocation();
    const formData = new FormData();
    const [isButtonDisable, setIsButtonDisable] = useState(true);
    const [loader, setLoader] = useState(0);
    const [nameErrors, setNameErrors] = useState('');
    const [emailErrors, setEmailErrors] = useState('');
    const [phoneErrors, setPhoneErrors] = useState('');
    const [countryCodeErrors, setCountryCodeErrors] = useState('');

    const [ndaError, setNdaError] = useState('');
    const [termsError, setTermsError] = useState('');
    const [appointmentGuestEmail, setAppointmentGuestEmail] = useState('');
    const [isTextFieldDisable, setIsTextFieldDisable] = useState(false);
    const [countryCode, setcountryCode] = useState([]);
    let { page_name } = useParams();
    const [state, setState] = useState({
        name: '',
        email: '',
        phone_number: '',
        company_name: '',
        additional_info: '',
        country: '',
        upload: '',
        is_nda: 0,
        is_term_conditions: 0,
        appointment_guest_email: "",
        country_code: {},
        country_code_id:''
    })
    let fields, budget, date, time, timeBook, timeDuration, timeZone, radioExtension, offerValues, field_category_id;
    if (page_name === "fixed-cost-calculator") {
        fields = location.state?.fields;
        budget = location.state?.budget;
    } else if (page_name === "appointment_calender") {
        date = location.state?.date;
        time = location.state?.time;
        timeBook = location.state?.timeBook;
        timeDuration = location.state?.timeDuration;
        timeZone = location.state?.timeZone
    } else if (page_name === "hire-your-own-team") {
        fields = location.state?.fields;
        radioExtension = location.state?.radio_extension;
        offerValues = location.state?.offerValues;
    } else if (page_name === "update-category-existing") {
        fields = location.state?.fields;
        field_category_id = location.state?.field_category_id
    }

    // console.log(date, time);
    useEffect(() => { window.scrollTo(0, 0)
    
           
     }, [state.countryCode,state.country_code])

    useEffect(() => {
        // loadCountrieslist()

        var arrCountryList = [{ value: '', label: 'Select', color: '#0052CC', },]

        masterData.countryCodewithflag.map((item, index) =>
            arrCountryList.push({
                value: item.dial_code,
                label: item.flag + '' + item.dial_code,
            })
        );
        setcountryCode(arrCountryList);
        
            // if(arrCountryList.length>0){ setState(prevState => ({
            //     ...prevState,
            //     country_code: arrCountryList[235]
            // }))
            // console.log(countryCode[235]);
            // }
        // console.log(countryCode[234]);

    }, [])

    /**
 * @author Sucheta Singha
 * @Date_Created 08-09-2024
 * @Date_Modified 08-09-2024
 * @function async
 * @functionName loadCountrieslist
 * @functionPurpose this function gets the list of country with country code.
 *
 * @functionParam {}
 *
 * @functionSuccess Success status and message.
 *
 * @functionError {Boolean} error is there.
 * @functionError {String} message  Description message.
 */
    async function loadCountrieslist() {
        GeneralService.apiGetCallRequestWithoutToken(RouteURL.getCountrieslist)
            .then((res) => {
                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    setcountryCode(res.data);
                } else {
                    toast.error(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                if (error.response.status === 401) {
                    localStorage.clear();
                    history.push("/login");
                    window.location.reload();
                }
            });
    }

    const handleChange = (e) => {
        var newValue;
        if (e.target.type === "checkbox") {
            const { id, checked } = e.target;
            newValue = checked ? 1 : 0;
            setState(prevState => ({
                ...prevState,
                [id]: newValue
            }))
        }
        else {
            const { id, value } = e.target
            newValue = value
            setState(prevState => ({
                ...prevState,
                [id]: (newValue ?? "").toString().trimStart()
            }))
        }


    }

    const handleChangeCountryCode = (e) => {
        setState(prevState => ({
            ...prevState,
            country_code_id: e?.value.trimStart()
        }))
        // console.log(e);

    };

    useEffect(() => {
        let checkValues = Object.values(state["name", "email", "phone_number", "country_code_id"]).every(item => item === true);
        if (page_name === "appointment_calender") {
            if (checkValues == false) setIsButtonDisable(false)
            else setIsButtonDisable(true)
        } else {
            if (checkValues == false && state.is_term_conditions == 1) setIsButtonDisable(false)
            else setIsButtonDisable(true)
        }
    }, [state["name", "email", "phone_number", "country_code_id"], state.is_term_conditions])



    const handleChangeFile = (e) => {
        const { id } = e.target
        setState(prevState => ({
            ...prevState,
            [id]: e.target.files[0]
        }))
        const fileChosen = document.getElementById('file-chosen');
        fileChosen.textContent = start_and_end(e.target.files[0].name);
    }

    const start_and_end = (str) => {
        if (str.length > 30) {
            return str.substr(0, 12) + '...' + str.substr(str.length - 10, str.length);
        }
        return str;
    }

    /* Validation Checking */
    const ValidateContactForm = (e) => {
        e.preventDefault();
        if (contactFormValidation()) {
            contactSubmitClick();
        }
    }

    const contactFormValidation = () => {
        let nameErrors, phoneNumberErrors, emailErrors, termsError, ndaError, countryCodeErrors;
        let formIsValid = true;
        let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        //Name
        if (!state.name) {
            formIsValid = false;
            nameErrors = "Name cannot be empty";
            setNameErrors(nameErrors);
        } else {
            setNameErrors('');
        }

        //Email

        if (!state.email) {
            formIsValid = false;
            setEmailErrors("Email can not be empty");
        } else if (!emailRegex.test(state.email)) {
            formIsValid = false;
            setEmailErrors('Invalid email address');
        } else {
            setEmailErrors('');
        }


        if (state.appointment_guest_email && !emailRegex.test(state.appointment_guest_email)) {
            formIsValid = false;
            setAppointmentGuestEmail('Invalid email address');
        } else {
            setAppointmentGuestEmail('');
        }


        //Phone Number

        if (!state.phone_number) {
            formIsValid = false;
            phoneNumberErrors = "Phone Number can not be empty";
            setPhoneErrors(phoneNumberErrors);
        } else {
            if (!!state.phone_number) {
                if (state.phone_number.length < 10 || state.phone_number.length > 15) {
                    // console.log(state.phone_number.length);
                    formIsValid = false;
                    setPhoneErrors("Phone no. should be min 10 and max 15 digits");
                } else setPhoneErrors("");

            }
            // setPhoneErrors('');
        }

        //Country Code
        if (!state.country_code_id) {
            formIsValid = false;
            countryCodeErrors = "Country Code can not be empty";
            setCountryCodeErrors(countryCodeErrors);
        } else {
            setCountryCodeErrors('');
        }


        if (page_name === "fixed-cost-calculator" || page_name === "hire-your-own-team" || page_name === "update-category-existing") {
            // if (!state.is_nda) {
            //     formIsValid = false;
            //     termsError = "Please accept NDA";
            //     setNdaError(termsError);
            // } else {
            //     setNdaError('');
            // }
            if (!state.is_term_conditions) {
                formIsValid = false;
                ndaError = "Please accept Terms and Conditions";
                setTermsError(ndaError);
            } else {
                setTermsError('');
            }

        }

        return formIsValid;
    }

    const contactSubmitClick = () => {
        setIsButtonDisable(true)
        setIsTextFieldDisable(true)
        setLoader(1);
        if (page_name === "fixed-cost-calculator") {
            formData.append("name", state.name ? state.name : null);
            formData.append("phone_number", state.phone_number ? state.country_code_id.toString() + state.phone_number : null);
            formData.append("email", state.email ? state.email : null);
            formData.append("company_name", state.company_name ? state.company_name : null);
            formData.append("additional_info", state.additional_info ? state.additional_info : null);
            formData.append("budget", budget ? budget : null);
            formData.append("currency", "INR");
            formData.append("is_nda", state.is_nda);
            formData.append("fields", JSON.stringify(fields));

            formData.append("attachments", state.upload ? state.upload : null);
            GeneralService.apiPostCallFormDataRequestWithoutToken(RouteURL.costContactFormSubmit, formData)
                .then((res) => {
                    setIsButtonDisable(false)
                    setIsTextFieldDisable(false)
                    if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                        localStorage.removeItem('fixed-cost-calculator')
                        localStorage.removeItem('budgetValues')
                        history.push({
                            pathname: `/mail-sent-details`,
                        });
                        setLoader(0);
                    } else {
                        toast.error(res.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                        setLoader(0);
                    }
                })
                .catch((error) => {
                    setIsButtonDisable(false)
                    setIsTextFieldDisable(false)
                    if (error.response.status === 401) {
                        console.log(error);

                    }
                });
        }
        if (page_name === "appointment_calender") {

            formData.append("name", state.name);
            formData.append("email", state.email);
            formData.append("phone_number", state.country_code_id.toString() + state.phone_number);
            formData.append("appointment_guest_email", state.appointment_guest_email);
            formData.append("page_details", "appointment_calender");
            formData.append("appointment_date", date);
            formData.append("appointment_time", (timeDuration == '30 min' ? timeBook?.split('-')[0].toString() : timeBook.toString()));
            formData.append("appointment_message", state.additional_info);
            formData.append("timezone_name", timeZone.timezone_name == 'Calcutta' ? 'Indian Standard Time' : timeZone.timezone_name);
            formData.append("timezone", timeZone.timezone);
            formData.append("attachments", state.upload ? state.upload : null);
            GeneralService.apiPostCallFormDataRequestWithoutToken(RouteURL.SalesAddContactWeb, formData)
                .then((res) => {
                    setIsButtonDisable(false)
                    setIsTextFieldDisable(false)
                    if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                        setLoader(0);
                        let response = res.data.addl_data;
                        setState({
                            name: '', email: '', phone_number: '', appointment_guest_email: '', additional_info: '', country_code_id: ''
                        })
                        history.push({
                            pathname: "/book-time-scheduled",
                            state: { date: response }
                        })
                    } else {
                        setLoader(0);
                        toast.error(res.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                    }
                })
                .catch((error) => {
                    setIsButtonDisable(false)
                    setIsTextFieldDisable(false)
                    if (error.response.status === 401) {
                        console.log(error);

                    }
                });
        }

        if (page_name === "hire-your-own-team") {
            formData.append("name", state.name ? state.name : null);
            formData.append("phone_number", state.phone_number ? state.country_code_id.toString() + state.phone_number : null);
            formData.append("email", state.email ? state.email : null);
            formData.append("company_name", state.company_name ? state.company_name : null);
            formData.append("message", state.additional_info ? state.additional_info : null);
            formData.append("team_categories", JSON.stringify(fields));
            formData.append("radio_extension", radioExtension);
            formData.append("is_nda", state.is_nda);
            formData.append("offer_id", JSON.stringify(offerValues));
            formData.append("attachments", state.upload ? state.upload : null);
            GeneralService.apiPostCallFormDataRequestWithoutToken(RouteURL.hireTeamContactFormSubmit, formData)
                .then((res) => {
                    setIsButtonDisable(false)
                    setIsTextFieldDisable(false)
                    if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                        localStorage.removeItem('team_structure');
                        localStorage.removeItem('radio_extension');
                        localStorage.removeItem('offerValues');
                        history.push({
                            pathname: `/mail-sent-details`,
                        });
                        setLoader(0);
                    } else {
                        toast.error(res.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                        setLoader(0);
                    }
                })
                .catch((error) => {
                    setIsButtonDisable(false)
                    setIsTextFieldDisable(false)
                    if (error.response.status === 401) {
                        console.log(error);

                    }
                });
        }



        if (page_name === "update-category-existing") {
            formData.append("name", state.name ? state.name : null);
            formData.append("phone_number", state.phone_number ? state.country_code_id.toString() + state.phone_number : null);
            formData.append("email", state.email ? state.email : null);
            formData.append("company_name", state.company_name ? state.company_name : null);
            formData.append("message", state.additional_info ? state.additional_info : null);
            formData.append("field_category_id", field_category_id);
            formData.append("is_nda", state.is_nda);
            formData.append("fields", JSON.stringify(fields));
            formData.append("attachments", state.upload ? state.upload : null);
            GeneralService.apiPostCallFormDataRequestWithoutToken(RouteURL.generateUpdationCost, formData)
                .then((res) => {
                    setIsButtonDisable(false)
                    setIsTextFieldDisable(false)
                    if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                        history.push({
                            pathname: `/mail-sent-details`,
                        });
                        localStorage.removeItem('update-category-existing')
                        setLoader(0);
                    } else {
                        toast.error(res.message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                        setLoader(0);
                    }
                })
                .catch((error) => {
                    setIsButtonDisable(false)
                    setIsTextFieldDisable(false)
                    if (error.response.status === 401) {
                        console.log(error);

                    }
                });
        }



    }




    const GoBackClick = (e) => {
        e.preventDefault();
        history.goBack()
    }

    // const sendHeight = () => {
    //     // Send the height of the iframe content to the parent page
    //     window.parent.postMessage(document.body.scrollHeight, '*');
    // }

    // // Send height initially and on content changes
    // window.addEventListener('load', sendHeight);
    // window.addEventListener('resize', sendHeight);

    // const observer = new MutationObserver(sendHeight);
    // observer.observe(document.body, { childList: true, subtree: true });


    const sendHeight = () => {
        // Send the height of the iframe content to the parent page
        window.parent.postMessage(document.body.scrollHeight, RAT_WEBSITE_ORIGIN);
    };

    // Debounce function to limit the number of times sendHeight is called
    const debounce = (func, delay) => {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, delay);
        };
    };

    // Create debounced version of sendHeight
    const debouncedSendHeight = debounce(sendHeight, 100);

    // Send height initially and on content changes
    window.addEventListener('load', debouncedSendHeight);
    window.addEventListener('resize', debouncedSendHeight);

    // Observe changes in the DOM with a slight delay to ensure rendering is complete
    const observer = new MutationObserver(debouncedSendHeight);
    observer.observe(document.body, { childList: true, subtree: true });
    return (
        <>
            <body style={{ backgroundColor: "#fff" }}>

                <div className="appoinment_hed">
                    <h4 className='mb-0'>
                        {(() => {
                            switch (page_name) {
                                case "fixed-cost-calculator":
                                    return "YOU ARE JUST A CLICK AWAY FROM AN  ESTIMATION ";
                                case "appointment_calender":
                                    return "ENTER THE FOLLOWING DETAILS FOR SCHEDULING METTING";
                                case "hire-your-own-team":
                                    return "YOU ARE JUST A CLICK AWAY FROM AN  ESTIMATION ";
                                case "update-category-existing":
                                    return "YOU ARE JUST A CLICK AWAY FROM AN  ESTIMATION ";

                                default:
                                    return null;
                            }
                        })()}
                    </h4>

                    {page_name === "appointment_calender" && <h5><b>{moment(date).format("DD MMMM, YYYY")}</b>{' | ' + moment(date).format("dddd") + ' | ' + (timeDuration == '30 min' ? timeBook?.split('-')[0] : timeBook) + ' | ' + timeDuration}</h5>}
                    {page_name != "appointment_calender" && <p style={{ textAlign: 'center' }}>We will discuss the project soon!</p>}

                    <CForm action="" method="post" encType="multipart/form-data" className="form-horizontal">

                        {loader ?
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', width: '100%', marginTop: "10%" }}> <CSpinner
                                style={{ width: '4rem', height: '4rem', }}
                                color="danger"
                                variant="grow"
                                className="loader_z_index"
                            />
                            </div>
                            : ""}
                        <div className="booking_field">
                            <div className='row'>
                                <div className="col-md-6">
                                    <div className='book_meeting'>
                                        <CInput
                                            type="text"
                                            placeholder="Name*"
                                            value={state.name}
                                            name="name"
                                            id="name"
                                            onChange={handleChange}
                                            disabled={isTextFieldDisable ? true : false}
                                        />
                                        <span className='error_book' style={{ color: "red" }}>{nameErrors}</span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className='book_meeting'>
                                        <CInput
                                            type="email"
                                            placeholder="Email*"
                                            value={state.email}
                                            name="email"
                                            id="email"
                                            onChange={handleChange}
                                            disabled={isTextFieldDisable ? true : false}
                                        />
                                        <span className='error_book' style={{ color: "red" }}>{emailErrors}</span>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className='row'>
                                        <div className='col-xxl-3 col-xl-3 col-lg-3 pr-0 col-3 col-md-4'>
                                            <div className='book_meeting countryCode'>{console.log(state?.country_code_id)}
                                                <Select className="dropdown"
                                                    name="country_code_id"
                                                    placeholder="Select"
                                                    // defaultValue={state.country_code}
                                                    options={countryCode}
                                                    isSearchable
                                                    isClearable={false}
                                                    onChange={handleChangeCountryCode}
                                                    
                                                />
                                                {/* <CSelect
                                                    custom
                                                    name="country_code_id"
                                                    id="country_code_id"
                                                    style={{ borderRight: 0, borderRadius: 0, color: state.country_code_id ? "#000" : "#aba4a4" }}
                                                    value={state.country_code_id}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                    }}
                                                    required
                                                >
                                                    {masterData.countryCodewithflag.map((item, index) => (
                                                     
                                                        <option key={item.dial_code} value={helpers.trim(item.dial_code)} >
                                                            {helpers.spaceBTW(item.dial_code, item.flag)}                                                           
                                                           
                                                        </option>
                                                    ))}
                                                   
                                                </CSelect> */}
                                                <span className='error_book' style={{ color: "red" }}>{countryCodeErrors}</span>
                                            </div>
                                        </div>
                                        <div className='col-xxl-9 col-xl-9 col-lg-9 pl-0 col-9 col-md-8'>

                                            <div className='book_meeting'>
                                                <CInput
                                                    type="number"
                                                    maxLength={10}
                                                    pattern="[0-9]*"
                                                    placeholder="Phone Number*"
                                                    value={state.phone_number}
                                                    name="phone_number"
                                                    id="phone_number"
                                                    onChange={handleChange}
                                                    disabled={isTextFieldDisable ? true : false}
                                                    onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                />
                                                <span className='error_book' style={{ color: "red" }}>{phoneErrors}</span>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                {(page_name === "fixed-cost-calculator" || page_name === "hire-your-own-team" || page_name === "update-category-existing") &&
                                    <div className="col-md-6">
                                        <div className='book_meeting'>
                                            <CInput
                                                type="text"
                                                placeholder="Company"
                                                value={state.company_name}
                                                name="company_name"
                                                id="company_name"
                                                onChange={handleChange}
                                                disabled={isTextFieldDisable ? true : false}
                                            />
                                        </div>
                                    </div>
                                }
                                {page_name === "appointment_calender" &&
                                    <div className="col-md-6">
                                        <div className='book_meeting'>
                                            <CInput
                                                type="email"
                                                placeholder="Add Guest Email"
                                                value={state.appointment_guest_email}
                                                name="appointment_guest_email"
                                                id="appointment_guest_email"
                                                onChange={handleChange}
                                                disabled={isTextFieldDisable ? true : false}
                                            />
                                            <span className='error_book' style={{ color: "red" }}>{appointmentGuestEmail}</span>
                                        </div>

                                    </div>
                                }



                                <div className="col-md-12">
                                    <div className='book_meeting'>
                                        <CTextarea
                                            name="additional_info"
                                            id="additional_info"
                                            rows="4"
                                            placeholder={page_name === "fixed-cost-calculator" ? "Additional Infomation you  want to share..." :
                                                (page_name === "appointment_calender" ? "Please share anything that will help prepare for our meeting" : "Write notes")}
                                            value={state.additional_info}
                                            onChange={handleChange}
                                            disabled={isTextFieldDisable ? true : false}
                                        />
                                    </div>
                                </div>



                                <div className="col-md-6">
                                    <div className='book_meeting'>

                                        <div className='book_meeting_file'>
                                            <input type="file" hidden name="attachment" id="upload" accept=".pdf,.doc,.docx,.xls,.xlsx,.zip,image/*"
                                                placeholder="Attachment" onChange={handleChangeFile}
                                                disabled={isTextFieldDisable ? true : false} />
                                            <label className='meeting_book_choose' for="upload">Choose File</label>
                                            <span id="file-chosen">No file chosen</span>
                                        </div>
                                        {/* <input type="file" name="attachment" id="attachment" accept=".pdf,.doc,.docx,.xls,.xlsx,.zip,image/*"
                                            placeholder="Attachment" onChange={handleChangeFile}
                                            disabled={isTextFieldDisable ? true : false}
                                        />
                                        <span className='upload'>Choose a File</span> */}
                                    </div>

                                </div>
                                {(page_name === "fixed-cost-calculator" || page_name === "hire-your-own-team" || page_name === "update-category-existing") &&
                                    <div className="col-md-6">
                                        <div className='con2 terms_sec_cal' style={{ display: "flex", alignItems: "center", justifyContent: "start", height: "35px", lineHeight: "35px" }}>
                                            {/* <input width="10px" type='checkbox' id="is_term_conditions" name="is_term_conditions" value={state.is_term_conditions} onChange={handleChange} /> */}
                                            <label class={"con1 label_drk"}>
                                                <input name="is_term_conditions" id="is_term_conditions" type='checkbox' value={state.is_term_conditions}
                                                    onChange={handleChange}
                                                />
                                                <span class="checkmark"></span>
                                            </label>


                                            <span> &nbsp; I agree with <a href="https://www.redappletech.com/terms-conditions/" target="_blank">Terms and Conditions</a></span>
                                        </div>
                                        <span style={{ color: "red" }}>{termsError}</span>
                                        <div className='con2 terms_sec_cal' style={{ display: "flex", alignItems: "center", justifyContent: "start", height: "35px", lineHeight: "35px" }}>
                                            <label class={"con1 label_drk"}>
                                                <input width="10px" type='checkbox' id="is_nda" name="is_nda" value={state.is_nda} onChange={handleChange} />
                                                <span class="checkmark"></span>
                                            </label>

                                            <span> &nbsp; Send me <a href="https://www.redappletech.com/wp-content/uploads/2024/09/NDA-Red-Apple.pdf" target="_blank">NDA</a></span>
                                        </div>
                                        {/* <span className='error_book' style={{ color: "red" }}>{ndaError}</span> */}
                                    </div>}
                            </div>

                        </div>
                        <div className="booking_btns_sec">
                            <div className="atten_sec1 col-12 text-center">
                                <CButton className="cancel" onClick={GoBackClick}
                                    style={{ background: isButtonDisable == true ? '#DFDFDF' : '#ABABAB', marginRight: 10 }}
                                ><i class="fa-solid fa-chevron-left"></i> Back</CButton>

                                <CButton className="save esti_btn"
                                    onClick={ValidateContactForm}
                                    disabled={isButtonDisable ? true : false}
                                    style={{ background: isButtonDisable ? '#DFDFDF' : '#E84C3D' }}
                                >

                                    {(() => {
                                        switch (page_name) {
                                            case "fixed-cost-calculator":
                                                return "Get My Estimation";
                                            case "appointment_calender":
                                                return "Schedule Meeting";
                                            case "hire-your-own-team":
                                                return "Get My Estimation";
                                            case "update-category-existing":
                                                return "Get My Estimation";
                                            default:
                                                return null;
                                        }
                                    })()}
                                    <i class="fa-solid fa-angle-right right_save"></i>

                                </CButton>

                            </div>
                        </div>
                    </CForm>

                </div>

            </body>
        </>


    )
}





